import router from '@/router'
import axios from 'axios'
import { useToast as toast } from 'vue-toastification'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

http.interceptors.request.use(
  (config) => {
    const jwt = localStorage.getItem('__access')
    if (jwt) {
      config.headers.authorization = `Bearer ${jwt}`
      config.headers.__company_id = localStorage.getItem('__company')
    }

    return config
  },
  (error) => {
    console.log(`Erro: ${error}`)
  }
)

http.interceptors.response.use(
  (res) => {
    return res
  },
  (err) => {
    if (err.response && err.response.status === 401) {
      const currentRoute = router.currentRoute.value
      const isClientRoute = currentRoute?.meta?.appC

      if (isClientRoute) {
        console.log('here 401', isClientRoute);
        
        router.push('/auth')
      } else {
        router.push('/login')
      }
    }

    if (err.response && err.response.status === 429) {
      const currentRoute = router.currentRoute.value
      const isClientRoute = currentRoute?.meta?.appC

      if (isClientRoute) {
        toast(
          'Aviso',
          'Multiplas tentativas, tente novamente mais tarde',
          'error'
        )
        router.push('/auth')
      } else {
        toast(
          'Aviso',
          'Multiplas tentativas, tente novamente mais tarde',
          'error'
        )
        router.push('/login')
      }
    }

    return Promise.reject(err)
  }
)

export { http }
